function downloadBase64Zip(base64: string, fileName: string) {
  const byteString: string = window.atob(base64)
  const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteString.length)
  const int8Array: Uint8Array<ArrayBuffer> = new Uint8Array(arrayBuffer)
  for (let i: number = 0; i < byteString.length; i++) {
    int8Array[i] = byteString.charCodeAt(i)
  }
  const file: File = new File([int8Array], fileName, { type: 'application/zip' })

  const url: string = window.URL.createObjectURL(file)
  const link: HTMLAnchorElement = document.createElement('a')
  link.href = url
  link.download = fileName

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

function downloadCsvFile(data: string, filename: string) {
  const blob: Blob = new Blob([data], { type: 'text/csv;charset=utf-8;' })

  const url: string = window.URL.createObjectURL(blob)
  const link: HTMLAnchorElement = document.createElement('a')
  link.href = url

  const date: string = new Date().toISOString().split('T')[0]
  link.download = `${filename}-${date}.csv`

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export { downloadBase64Zip, downloadCsvFile }
